export enum CashTypeEnum {
  CASH = 'CASH',
  ONE_PAY = 'ONE_PAY',
  RETURN = 'RETURN',
}
